import { render } from "./pharmacymodel.vue?vue&type=template&id=4f3dd062"
import script from "./pharmacymodel.vue?vue&type=script&lang=js"
export * from "./pharmacymodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__